import { CommonModule } from '@angular/common';
import { ENVIRONMENT_INITIALIZER, inject, NgModule, ValueProvider } from '@angular/core';
import { environment, FAKE_DB_COLLECTIONS_TOKEN } from '@mri-platform/shared/core';
import { ENTITY_METADATA_TOKEN, EntityServices, PLURAL_NAMES_TOKEN } from '@ngrx/data';
import {
  AccessTokenEntityService,
  ApiEntityService,
  DataSourceClientEntityService,
  DataSourceEntityService,
  entityMetadata,
  FileDataEntityService,
  MetaDataEntityService,
  pluralNames,
  RefreshApiHistoryEntityService
} from './data-access';
import { devDb } from './testing/dev-dataset';
import { testDb } from './testing/test-dataset';

export const entityStateInitProvider: ValueProvider = {
  provide: ENVIRONMENT_INITIALIZER,
  useValue: () => {
    const entityServices = inject(EntityServices);
    entityServices.registerEntityCollectionServices([
      inject(AccessTokenEntityService),
      inject(ApiEntityService),
      inject(DataSourceEntityService),
      inject(DataSourceClientEntityService),
      inject(MetaDataEntityService),
      inject(RefreshApiHistoryEntityService),
      inject(FileDataEntityService)
    ]);
  },
  multi: true
};

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: PLURAL_NAMES_TOKEN, multi: true, useValue: pluralNames },
    { provide: ENTITY_METADATA_TOKEN, multi: true, useValue: entityMetadata },
    { provide: FAKE_DB_COLLECTIONS_TOKEN, multi: true, useValue: environment.dev ? devDb : testDb },
    entityStateInitProvider
  ]
})
export class CommonStateModule {}
